var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "div",
        {
          staticClass:
            "row mx-auto d-flex align-items-center panel-wrapper rounded px-4 py-3",
          class: `bg-${_vm.customBackgroundColor} text-${_vm.customColor} border-${_vm.customBorderColor}`
        },
        [
          _c("i", {
            staticClass: "fas font-22 icon",
            class: `${_vm.customIcon} text-${_vm.customIconColor}`
          }),
          _c("div", { staticClass: "content pl-3" }, [
            _vm._v(" " + _vm._s(_vm.message) + " "),
            _vm.hyperlinkConfig.text
              ? _c("span", [
                  _vm._v(" -  "),
                  _c(
                    "a",
                    {
                      staticClass: "hyperlink",
                      class: `text-${_vm.customColor}`,
                      on: { click: _vm.hyperlinkConfig.goTo }
                    },
                    [_vm._v(" " + _vm._s(_vm.hyperlinkConfig.text) + " ")]
                  )
                ])
              : _vm._e()
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }